import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// utils
import { translation } from '../../../../utils/helpers'
import { renderDate } from '../../../../utils/time'

// actions
import { getReleases, postRelease, getResponseTimeStatistics } from '../../../../actions/performance'

// elements
import TableRow from '../../../../shared/elements/tableRow'
import RemoveButton from '../../../../shared/elements/removeButton'
import AddButton from '../../../../shared/elements/addButton'
import DateTime from '../../../../shared/elements/datetime'
import Text from '../../../../shared/elements/text'
import Panel from '../../../../shared/elements/panel'
import EChart from '../../../../shared/components/EChart'
import DropDown from '../../../../shared/elements/dropDown'
import Inline from '../../../../shared/elements/inline'

// style
import './index.scss'

const statisticsType = {
  Day: 0,
  Week: 1
}

class ResponseTime extends Component {
  constructor (props) {
    super(props)
    this.state = {
      statisticsType: statisticsType.Day,
      releases: [],
      newRelease: {
        Date: new Date(),
        VersionText: ''
      },
      isLoading: false,
      statistics: {
        XAxis: [],
        TotalRequests: [],
        AveregeRequestTimeMs: [],
        Over5s: [],
        Over10s: [],
        Over30s: [],
        Over60s: [],
        Over120s: [],
        Over300s: [],
        Over600s: []
      }
    }

    this.getStatistics = this.getStatistics.bind(this)
    this.getReleases = this.getReleases.bind(this)
    this.postRelease = this.postRelease.bind(this)

    this.renderReleases = this.renderReleases.bind(this)
    this.renderStatistics = this.renderStatistics.bind(this)
  }

  componentDidMount () {
    this.getStatistics()
    this.getReleases()
  }

  getStatistics () {
    this.props.getResponseTimeStatistics(this.state.statisticsType).then((res) => {
      this.setState({
        statistics: res.data
      })
    })
  }

  getReleases () {
    this.props.getReleases().then((res) => {
      this.setState({
        releases: res.data
      })
    })
  }

  postRelease (release) {
    return this.props.postRelease(release).then((res) => {
      this.setState({ releases: res.data })
      // window.toastr.success(translation('893'), translation('13424'))
    }, () => {
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  renderReleases () {
    const renderAdd = () => {
      const onChange = (e) => {
        let value = ''
        let name = ''
        if (typeof e.target !== 'undefined') {
          value = e.target.value
          name = e.target.name
        } else {
          value = e
          name = 'Date'
        }
        this.setState({
          newRelease: {
            ...this.state.newRelease,
            [name]: value
          }
        })
      }

      const addRelease = () => {
        this.setState({ isLoading: true }, () => this.postRelease(this.state.newRelease).then(() => {
          this.setState({ isLoading: false, newRelease: { Date: new Date(), VersionText: '' } })
        }))
      }

      return (
        <TableRow>
          <DateTime
            inputProps={{
              name: 'Date',
              placeholder: translation('1728'),
              readOnly: true
            }}
            dateFormat='DD-MM-YYYY'
            timeFormat={false}
            closeOnSelect
            value={this.state.newRelease.Date}
            onChange={onChange}
            size='m' />
          <Text name='VersionText' value={this.state.newRelease.VersionText} onChange={onChange} size='m' />
          <AddButton spacing={0} onClick={addRelease} disabled={this.state.isLoading} size='m' />
        </TableRow>
      )
    }

    const renderRelease = (item, key) => {
      return (
        <TableRow key={key}>
          <span>{renderDate(item.Date)}</span>
          <span>{item.VersionText}</span>
          <RemoveButton spacing={0} onClick={() => this.postRelease({...item, IsDeleted: true})} size='m' />
        </TableRow>
      )
    }

    return (
      <Panel title={translation(18371)} id='releases'>
        <TableRow header>
          <span>{translation(388)}</span>
          <span>{translation(1229)}</span>
        </TableRow>
        {renderAdd()}
        {this.state.releases.map(renderRelease)}
      </Panel>
    )
  }

  renderStatistics () {
    let zoomStart = moment().add({months: -3})
    let marks = this.state.releases.map(x => { return [{ name: x.VersionText, xAxis: renderDate(x.Date) }, { xAxis: renderDate(moment(x.Date).add({days: 1})) }] })
    let dataZoom = [{ startValue: renderDate(zoomStart) }, { type: 'inside' }]
    if (this.state.statisticsType === statisticsType.Week) {
      // formatted for ISO week of year i.e 01,02...52,53
      marks = this.state.releases.map(x => { return [{ name: x.VersionText, xAxis: `${moment(x.Date).year()}, ${moment(x.Date).format('WW')}` }, { xAxis: `${moment(x.Date).add({days: 7}).year()}, ${moment(x.Date).add({days: 7}).format('WW')}` }] })
      dataZoom[0].startValue = `${zoomStart.year()}, ${zoomStart.format('WW')}`
    }
    let releaseMarks = { type: 'line', markArea: { itemStyle: { color: 'rgba(128, 128, 128, 0.3)' }, data: marks } }

    return (
      <div id='graphs'>
        <Panel title={translation(18372)}>
          <EChart options={{
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '10%']
              }
            },
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: 'none'
                },
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              data: this.state.statistics.XAxis
            },
            yAxis: {
              type: 'value'
            },
            dataZoom: dataZoom,
            series: [
              {
                name: translation(18373),
                type: 'line',
                data: this.state.statistics.TotalRequests
              },
              releaseMarks
            ]
          }} />
        </Panel>

        <Panel title={translation(18374)}>
          <EChart options={{
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '10%']
              }
            },
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: 'none'
                },
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              data: this.state.statistics.XAxis
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value} ms'
              }
            },
            dataZoom: dataZoom,
            series: [
              {
                name: translation(18375),
                type: 'line',
                data: this.state.statistics.AveregeRequestTimeMs
              },
              releaseMarks
            ]
          }} />
        </Panel>

        <Panel title={translation(18370)}>
          <EChart options={{
            tooltip: {
              trigger: 'axis',
              position: function (pt) {
                return [pt[0], '10%']
              }
            },
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: 'none'
                },
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              data: this.state.statistics.XAxis
            },
            yAxis: {
              type: 'value'
            },
            dataZoom: dataZoom,
            series: [
              {
                name: translation(18376),
                type: 'line',
                data: this.state.statistics.Over5s
              },
              {
                name: translation(18377),
                type: 'line',
                data: this.state.statistics.Over10s
              },
              {
                name: translation(18378),
                type: 'line',
                data: this.state.statistics.Over30s
              },
              {
                name: translation(18379),
                type: 'line',
                data: this.state.statistics.Over60s
              },
              {
                name: translation(18380),
                type: 'line',
                data: this.state.statistics.Over120s
              },
              {
                name: translation(18381),
                type: 'line',
                data: this.state.statistics.Over300s
              },
              {
                name: translation(18382),
                type: 'line',
                data: this.state.statistics.Over600s
              },
              releaseMarks
            ]
          }} />
        </Panel>
      </div>
    )
  }

  renderHeader () {
    const onChange = ({ target }) => this.setState({ [target.name]: target.value }, this.getStatistics)
    return (
      <div className='top-bar'>
        <Inline>
          <DropDown size='m' name='statisticsType' onChange={onChange} value={this.state.statisticsType}>
            <option value={statisticsType.Day}>{translation('483')}</option>
            <option value={statisticsType.Week}>{translation('250')}</option>
          </DropDown>
        </Inline>
      </div>
    )
  }

  render () {
    return (
      <div className='responsetime'>
        {this.renderHeader()}
        {this.renderStatistics()}
        {this.renderReleases()}
      </div>
    )
  }
}

export default connect(null, {
  getReleases,
  postRelease,
  getResponseTimeStatistics
})(ResponseTime)



// WEBPACK FOOTER //
// ./src/app/pages/Performance/pages/responseTime/index.js